export default "__VITE_ASSET__b83da424__"